"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Lightning24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("g", { id: "Icons/Lightning/24", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { d: "M18,1 L15,7 L21.5171573,7 C21.6276142,7 21.7171573,7.08954305 21.7171573,7.2 C21.7171573,7.2530433 21.6960859,7.30391408 21.6585786,7.34142136 L6.56530296,22.434697 C6.4871981,22.5128019 6.36056511,22.5128019 6.28246025,22.434697 C6.23024781,22.3824846 6.21105155,22.3057515 6.2325283,22.2351043 L9.04,13 L9.04,13 L3.3236068,13 C3.21314985,13 3.1236068,12.9104569 3.1236068,12.8 C3.1236068,12.768951 3.13083582,12.7383284 3.14472136,12.7105573 L9,1 L9,1 L18,1 Z M14.764,3 L10.235,3 L6.235,11 L11.7383741,11 L10.238,15.932 L17.17,9 L11.763932,9 L14.764,3 Z", id: "Rectangle", fill: "#383F49", fillRule: "nonzero" })));
}
function Lightning24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Lightning24Svg, Object.assign({}, svgProps)));
}
exports.default = Lightning24;
//# sourceMappingURL=Lightning24.js.map